import classes from "./Button.module.css";

const Button = (props) => {
  //onClick
  //buttonText

  let buttonClassSize = classes.button;

  switch (props.size) {
    case "small":
      buttonClassSize = classes.smallButton;
      break;
    default:
      buttonClassSize = classes.button;
  }

  return (
    <button className={buttonClassSize} onClick={props.onClick}>
      {props.buttonText}
    </button>
  );
};

export default Button;
